import React from 'react';
import { connect } from 'react-redux';

class MenuItemModifier extends React.Component {

    constructor(props) {
        super(props);
    }
    
    render() {
        return (
            <div>
                <div className="section-title">
                    <p className="selectionTitleText">{this.props.children}</p>
                </div>

                <div className="menu-item-choice-selection-window">
                    {this.props.foodItemModifier.modifier.items.map((item) => {
                        
                        let title = (parseFloat(item.prices[0].price) > 0) ? item.name + " - " + item.prices[0].price : item.name;
                        if(item.enabled == 0){
                            title += " - Currently unavailable";
                        }

                        if (this.props.foodItemModifier.max > 1) {
                            return (
                                <div key={item.id} className="menu-item-choice-window">
                                    <label class={item.enabled == 0 ? "container disabled" : "container"} for={"item-"+item.id}>
                                        {title}
                                        <input 
                                            type="checkbox"
                                            onClick={() => { 
                                                this.props.updateMultipleModifierSelection(this.props.foodItemModifier.id, item);
                                            }}
                                            checked={this.props.isModifierSelected(this.props.foodItemModifier.id, item.id) || false}
                                            id={"item-"+item.id}
                                            disabled={item.enabled == 0}
                                        />
                                        <span className="checkmark"></span>
                                    </label>
                                </div>
                            );
                        } else {
                            return (
                                <div key={item.id} className="menu-item-choice-window">
                                    <label class={item.enabled == 0 ? "container disabled" : "container"} for={"item-"+item.id}>
                                        {title}
                                        <input 
                                            type="checkbox"
                                            onClick={() => { 
                                                this.props.updateSingleModifierSelection(this.props.foodItemModifier.id, item);
                                            }}
                                            checked={this.props.isModifierSelected(this.props.foodItemModifier.id, item.id) || false}
                                            id={"item-"+item.id}
                                            disabled={item.enabled == 0}
                                        />
                                        <span className="radio-checkmark"></span>
                                    </label>
                                </div>
                            );
                        }
                    })}
                </div>
            </div>
        );
    }
};

const mapStateToProps = (state) => {

    return {
        cartItem: state.cartItem
    };
};

export default connect(mapStateToProps)(MenuItemModifier);